import { useState } from "react"
import "../Styles/Signup.css"
import { Input, PasswordInput, TextInput } from '@mantine/core';
import { NavLink } from "react-router-dom";
import VerifyOtp from "../components/VerifyOtp";
import { toast } from "react-toastify";
import logo from "../assets/images/logo3.jpg"
import { click } from "@testing-library/user-event/dist/click";
import axios from "axios";
import { url } from "../db/url";

const Signup = () => {
    const [details, setDetails] = useState({
        name: "",
        email: "",
        password: ""
    })
    const [showModal, setShowModal] = useState(false)
    const [loading, setLoading] = useState(false)

    const handleSubmit = (e) => {
        setLoading(true)
        axios.post(`${url}/api/v2/user/create-user`, {...details})
        .then(res => {
            toast.success("Please check your email/spam for 6/7 digit otp");
            setLoading(false)
            setShowModal(true)
        }).catch(err => {
            toast.error(err.response? err.response.data.message : "Network Error");
            setLoading(false) 
        })
        e.preventDefault()
    }
    const handleClose = () => {
        setShowModal(false)
    }
    
    return<>
    <VerifyOtp modal={showModal} onClose={handleClose} email={details['email']} />
        <section className="signup">
            <div className="signupWrapper">
                <img src={logo} alt="" />
                <form action="" >
                    <div className="formHeading">
                        <h2>Sign Up</h2>
                        <p>Sign up to your farmcart account</p>
                    </div>

                    <div className="inputContainer">
                        <TextInput
                            label="Name"
                            description="Enter your full name"
                            placeholder="John Doe"
                            type="text"
                            withAsterisk
                            value={details['name']}
                            onChange={(e) => setDetails({...details, name: e.target.value})}
                        />
                        <TextInput
                            label="Email Address:"
                            description="Enter a valid email address"
                            placeholder="abc@example.com"
                            type="email"
                            withAsterisk
                            value={details['email']}
                            onChange={(e) => setDetails({...details, email: e.target.value})}
                        />
                        <PasswordInput
                            withAsterisk
                            label= "Password"
                            description="Please enter a strong password"
                            placeholder="*******"
                            value={details['password']}
                            onChange={(e) => setDetails({...details, password: e.target.value})}
                            className="passwordinput"
                        />
                    </div>
                    <button type="submit" className="btn" onClick={handleSubmit} disabled={loading}>{loading ? "Loading..." : "Sign Up"}</button>
                    <p className="lastChild">Already have an account? <NavLink to={"/signin"}>Sign In</NavLink></p>
                </form>
            </div>
        </section>
    </>

}

export default Signup